import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RenderTextField from "../inputs/renderTextField";
import PersonFormValidation from "../validation/forms/personFormValidator";
import Button from '@material-ui/core/Button';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from '@material-ui/core/MenuItem';

const PersonsFilterForm =  (props) =>{
  const {filterPersons, handleSubmit, roles, departments, handleCancel} = props;
  return (
    <form onSubmit={handleSubmit(filterPersons)}>
      <div className={'form-group'}>
        <Field name="username" label={'Username'} component={RenderTextField} type="text" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field name="email" label={'Email'} component={RenderTextField} type="email" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Field name="departmentId" label={'Department'} component={RenderSelectField} fullWidth>
          {
            departments.map( department => (
              <MenuItem value={department.id} key={department.id}>{department.name}</MenuItem>
            ))
          }
        </Field>
      </div>
      <div className={'form-group'}>
        <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
          {'Filter'}
        </Button>
        <Button onClick={handleCancel} variant="contained" color="secondary">
          {'Cancel'}
        </Button>
      </div>

    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'personsFilterForm',
})(PersonsFilterForm);



// WEBPACK FOOTER //
// ./src/components/personsList/personsFilterForm.js